import { render, staticRenderFns } from "./StrengthInfo.vue?vue&type=template&id=1e1a6d08&scoped=true"
import script from "./StrengthInfo.vue?vue&type=script&lang=js"
export * from "./StrengthInfo.vue?vue&type=script&lang=js"
import style0 from "./StrengthInfo.vue?vue&type=style&index=0&id=1e1a6d08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1a6d08",
  null
  
)

export default component.exports